import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-connection-failed',
  templateUrl: './connection-failed.component.html',
  styleUrls: ['./connection-failed.component.css']
})
export class ConnectionFailedComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/errors/connection-failed/connection-failed.component.ts